import { featureItems } from "@/mocks/homeData";

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-5">
            <div className="w-full h-[280px] md:h-[420px] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20cozy%20viewing%20space%20with%20warm%20lamp%20light%2C%20rose%20and%20amber%20color%20palette%2C%20soft%20painterly%20texture%2C%20minimal%20abstract%20decor%2C%20no%20text%2C%20elegant%20editorial%20composition&width=800&height=1000&seq=yjd-anime-feature-01&orientation=portrait"
                alt="平台内容与浏览体验示意插画"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
              <i className="ri-magic-line" />
              功能与内容特色
            </span>
            <h2 className="mt-3 font-heading text-foreground-950 text-2xl md:text-4xl">
              让找片和追更更省心的几点设计
            </h2>
            <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
              一个顺手的平台，往往体现在细节上：能不能快速找到想看的、换设备后收藏还在不在、弱网时是否还能顺畅浏览。
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {featureItems.map((item) => (
                <div key={item.title} className="flex gap-3.5">
                  <span className="shrink-0 w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-800 text-xl">
                    <i className={item.icon} />
                  </span>
                  <div>
                    <h3 className="font-heading text-foreground-950 text-base">{item.title}</h3>
                    <p className="mt-1.5 text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}